const R = require('ramda')
const httpFuture = require('../lib/http-future')

const buildURI = R.join('/')
const BODY = 'body'
const getBody = R.map(R.prop(BODY))

function fantasyCRUDRequest (camelCaseName, lowerCasePlural) {
  const basePath = `/${lowerCasePlural}`
  const createEntityURI = R.compose(buildURI, R.append(R.__, [ basePath ]))
  const getPayload = R.map(R.path([ BODY, camelCaseName ]))
  const createBody = R.createMapEntry(camelCaseName)

  const self = {}

  self.get = R.compose(
    getPayload,
    httpFuture.get,
    createEntityURI
  )

  self.create = R.compose(
    getPayload,
    httpFuture.postWithData(basePath),
    createBody
  )

  self.update = R.compose(
    getPayload,
    R.useWith(
      httpFuture.putWithData,
      createEntityURI,
      createBody
    )
  )

  self.del = R.compose(
    getBody,
    httpFuture.del,
    createEntityURI
  )

  return self
}

module.exports = fantasyCRUDRequest
